import React, { useState } from "react";
import { API_URL } from "../../config";
import "./LoginForm.css"
import logo from '../../assets/avispat.png';

function LoginForm({ onLoginSuccess }) {
  const [username, setUsername] = useState('');
  const [password, setPassword] = useState('');
  const [error, setError] = useState(null);

  const handleSubmit = async (e) => {
    e.preventDefault();
    setError(''); // Resetea el error

    try {
      const res = await fetch( `${API_URL}auth/login`, {
        method: 'POST',
        headers: { 'Content-Type': 'application/json' },
        body: JSON.stringify({ username, password })
      });

      const data = await res.json();

      if (res.ok) {
        localStorage.setItem('token', data.token);
        localStorage.setItem('username', username);
        localStorage.setItem('fullname', data.fullname);
        onLoginSuccess(); // Notifica al padre que el login fue exitoso
      } else {
        setError(data.message || 'Error al iniciar sesión');
      }
    } catch (err) {

      console.error('Error de login:', err);
    }
  };

  return (
    <><div className="login">
        {error && <p className="error-message">{error}</p>}
        <form className="login-form" onSubmit={handleSubmit}>
          <img src={logo} alt="logo avísPAT" className="logo" />
          <input type="username" value={username} onChange={(e) => setUsername(e.target.value)} placeholder="Usuario" />
          <input type="password" value={password} onChange={(e) => setPassword(e.target.value)} placeholder="Contraseña" />
          <button type="submit">Entrar</button>
        </form>
      </div>
    </>
  );
}

export default LoginForm;
